function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { AuthProviders } from '@/types/server';
import { useSearchParams, useNavigate, useParams } from 'react-router';
import { connectProvider } from '@/actions/AuthActions';
import { WebRoutes } from '@/utils/constants';
import useAuthenticationStore from '@/stores/AuthenticationStore';
import serializePath, { sanitizePathname } from '@/utils/url';
import useHydrated from '@/hooks/useHydrated';
import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import Notice from '../Notice';
import Cube from '../icons/lord/Cube';
import { LordIconSizes } from '@/types/client';
import useLoginRedirect from '@/hooks/useLoginRedirect';
import { HTTPError } from '@/utils/api';
import { useShallow } from 'zustand/react/shallow';
export default function LoginCallback() {
    var provider = useParams().provider;
    var _useSearchParams = _sliced_to_array(useSearchParams(), 1), query = _useSearchParams[0];
    var navigate = useNavigate();
    var intl = useIntl();
    var _useAuthenticationStore = useAuthenticationStore(useShallow(function(state) {
        return {
            redirectPath: state.redirectPath,
            setAccessToken: state.setAccessToken,
            setProvider: state.setProvider,
            setUnverified2FA: state.setUnverified2FA,
            setRedirectPath: state.setRedirectPath,
            setAuthState: state.setAuthState
        };
    })), redirectPath = _useAuthenticationStore.redirectPath, setAccessToken = _useAuthenticationStore.setAccessToken, setProvider = _useAuthenticationStore.setProvider, setUnverified2FA = _useAuthenticationStore.setUnverified2FA, setRedirectPath = _useAuthenticationStore.setRedirectPath, setAuthState = _useAuthenticationStore.setAuthState;
    var isHydrated = useHydrated(useAuthenticationStore);
    var redirectLogin = useLoginRedirect(redirectPath);
    React.useEffect(function() {
        var authenticateProvider = function authenticateProvider() {
            return _authenticateProvider.apply(this, arguments);
        };
        function _authenticateProvider() {
            _authenticateProvider = _async_to_generator(function() {
                var code, state, authProvider, data, _sanitizePathname, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!isHydrated) {
                                return [
                                    2
                                ];
                            }
                            code = query.get('code');
                            state = query.get('state');
                            if (code == null || state == null || provider == null || !Object.values(AuthProviders).includes(provider) && provider !== 'sso') {
                                redirectLogin();
                                return [
                                    2
                                ];
                            }
                            authProvider = provider;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                connectProvider(authProvider, code, state)
                            ];
                        case 2:
                            data = _state.sent();
                            if (authProvider === 'sso' || data == null) {
                                navigate(WebRoutes.LOGIN_AUTHORIZED);
                                return [
                                    2
                                ];
                            }
                            setProvider(authProvider);
                            setUnverified2FA(data.unverified2FA);
                            setAccessToken(data.accessToken);
                            if (data.unverified2FA) {
                                navigate(serializePath(WebRoutes.TWO_FACTOR, {
                                    return_to: redirectPath
                                }));
                            } else {
                                setRedirectPath(null);
                                ;
                                navigate((_sanitizePathname = sanitizePathname(redirectPath)) !== null && _sanitizePathname !== void 0 ? _sanitizePathname : WebRoutes.DASHBOARD);
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            // this edge case is for when the user is a bot and needs to re-authorize with
                            // additional provider bot scopes
                            if (_instanceof(error, HTTPError) && error.body != null && 'authorizationUrl' in error.body && 'authorizationState' in error.body) {
                                setAuthState(error.body.authorizationState);
                                window.location.href = error.body.authorizationUrl;
                            }
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return _authenticateProvider.apply(this, arguments);
        }
        authenticateProvider();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isHydrated
    ]);
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "wxHfW/",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Logging into "
                        },
                        {
                            type: 1,
                            value: "provider"
                        }
                    ]
                }, {
                    provider: provider
                })
            }),
            /*#__PURE__*/ _jsx(Notice, {
                beforeElement: /*#__PURE__*/ _jsx(Cube, {
                    size: LordIconSizes.MEDIUM,
                    trigger: "loop"
                }),
                description: intl.formatMessage({
                    id: "wxHfW/",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Logging into "
                        },
                        {
                            type: 1,
                            value: "provider"
                        }
                    ]
                }, {
                    provider: provider
                })
            })
        ]
    });
}
